module.exports = "https://bper-network.servercdn.it/static/img/story1.jpg?1e6b161ced8a075af17d3a9cc64d2189";